import { render, staticRenderFns } from "./ReferralPartner.vue?vue&type=template&id=dd3f9004&scoped=true&"
import script from "./ReferralPartner.vue?vue&type=script&lang=js&"
export * from "./ReferralPartner.vue?vue&type=script&lang=js&"
import style0 from "./ReferralPartner.vue?vue&type=style&index=0&id=dd3f9004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3f9004",
  null
  
)

export default component.exports